import { Component, OnInit } from "@angular/core";
import * as echarts from "echarts";

import { ChartService } from "src/app/shared/chart.service";
import { UserService } from "src/app/shared/user.service";
@Component({
  selector: "app-graph-chart",
  templateUrl: "./graph-chart.component.html",
  styleUrls: ["./graph-chart.component.css"],
})
export class GraphChartComponent implements OnInit {
  statusLabel: any[] = [];
  statusValue: any[] = [];
  Label: any[] = [];
  Value: any[] = [];
  chart: any;

  constructor(public chartService: ChartService, private userService: UserService) {}

  async ngOnInit() {
    await this.chartService.getContractStatus().subscribe((res: any) => {
      let data = res.contractsList;

      if (data !== null) {
        for (let index = 0; index < data.length; index++) {
          if (data[index].value !== null) {
            this.statusLabel.push(data[index].key);
            this.statusValue.push(data[index].value);
          }
        }
        this.contractBystatus(this.statusLabel, this.statusValue);
      }
    });

    await this.chartService.getContractByTranc().subscribe((res: any) => {
      let resData = res.contractsList;

      if (resData !== null) {
        for (let index = 0; index < resData.length; index++) {
          if (resData[index].value !== null) {
            this.Label.push(resData[index].key);
            this.Value.push(resData[index].value);
          }
        }
        this.chartByTran(this.Label, this.Value);
      }
    });
  }

  contractBystatus(statusLabel: any, statusValue: any) {
    this.chart = echarts.init(document.getElementById("pie2"));

    const colors = [
      "rgb(88,192,141)",
      "rgb(159,175,188)",
      "rgb(232,187,39)",
      "rgb(242,104,0)",
      "rgb(109,197,204)",
      "rgb(113,142,202)",
      "rgb(177,16,48)",
    ];

    const option = {
      tooltip: {
        trigger: "item",

        textStyle: {
          fontFamily: "Poppins",
        },
      },
      legend: {
        orient: "vertical",
        right: "right",
        top: "center",
        data: statusLabel,
        textStyle: {
          fontFamily: "Poppins",
          fontSize: 13,
        },
      },
      series: [
        {
          name: "Access From Contracts",
          type: "pie",
          avoidLabelOverlap: false,
          radius: ["40%", "70%"],
          center: ["40%", "50%"],
          data: statusLabel.map((label, index) => ({ value: statusValue[index], name: label })),
          itemStyle: {
            borderRadius: 6,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            fontFamily: "Poppins",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 15,
              fontWeight: 500,
              fontFamily: "Poppins",
            },
          },
          color: colors,
          animationType: "scale", // Add animation type
          animationEasing: "Sinusoidal In", // Add animation easing
          animationDelay: function (idx) {
            return idx * 100; // Add animation delay for each data item
          },
        },
      ],
    };

    this.chart.setOption(option);
  }
  chartByTran(trancLabel: any, trancValue: any) {
    this.chart = echarts.init(document.getElementById("pie"));

    const colors = [
      "rgb(114,194,198)",
      "rgb(37,89,135)",
      "rgb(163,211,156)",
      "rgb(231,182,25)",
      "rgb(97,141,164)",
      "rgb(65,109,192)",
      "rgb(177,16,48)",
      "rgb(88,192,141)",
    ];

    const option = {
      tooltip: {
        trigger: "item",
        // formatter: '{a} <br/>{b}: {c} ({d}%)',
        textStyle: {
          fontFamily: "Poppins",
        },
      },
      legend: {
        orient: "vertical",
        right: "right", // Change legend position to 'right'
        top: "center", // Change legend alignment to 'center'
        data: trancLabel,
        textStyle: {
          fontFamily: "Poppins",
          fontSize: 13,
        },
      },
      series: [
        {
          name: "Access From Contracts",
          type: "pie",
          avoidLabelOverlap: false,
          radius: ["40%", "70%"],
          center: ["40%", "50%"],
          data: trancLabel.map((label, index) => ({ value: trancValue[index], name: label })),
          itemStyle: {
            borderRadius: 6,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            textStyle: {
              fontFamily: "Poppins",
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 15,
              fontWeight: 500,
              fontFamily: "Poppins",
            },
          },
          color: colors,
          animationType: "scale", // Add animation type
          animationEasing: "Sinusoidal In", // Add animation easing
          animationDelay: function (idx) {
            return idx * 100; // Add animation delay for each data item
          },
        },
      ],
    };
    this.chart.setOption(option);
  }

}
